
import { Vue, Component } from 'vue-property-decorator'
import { performanceStatistics, TotalDataDTO } from '@/api/dataReport'
import { exportFileWithData } from '@/utils/h5ToApp'
import dayjs from 'dayjs'
import DataSelect from '@/views/dataReport/template/dataSelect.vue'
import { GetOrganizationInfoAll } from '@/api/customerManage'
import { moneyFormat, handlePercentage } from '@/utils/util'
import { Getter } from 'vuex-class'
import OrderListCard from '@/views/dataReport/template/OrderListCard.vue'
import KPIMoreFilter from '@/views/dataReport/template/KPIMoreFilter.vue'

@Component({
  name: 'EmployeeKpi',
  components: {DataSelect, OrderListCard, KPIMoreFilter}
})
export default class EmployeeKpi extends Vue {
  @Getter companyId!: string
  moneyFormat = moneyFormat
  handlePercentage = handlePercentage
  readonly format = 'YYYY-MM-DD'
  show = false
  queryParams = {
    startDate: dayjs().format(this.format),
    endDate: dayjs().format(this.format),
    deptId: '', // 部门筛选
    employeeName: '', // 员工姓名
    orderType: '', //  下单方式
    customerGroup: '', // 客户类别
    pageSize: 10,
    pageIndex: 1
  }

  loading = false
  finished = false
  refreshing = false

  depList = [] // 部门数据
  list = [] //列表数据
  totalData: TotalDataDTO | any = {} //头部统计总数据

  gridData = [
    {
      title: '订单收货数量',
      key: 'receiveAmount'
    },
    {
      title: '订单收货金额',
      key: 'receiveMoneyAmount',
      type: 'money'
    },
    {
      title: '服务客户数',
      key: 'serviveCusAmount'
    },
    {
      title: '退单退货金额',
      key: 'returnMoneyAmount',
      type: 'money'
    },
    {
      title: '退单退货占比',
      key: 'returnAmountRate'
    },
    {
      title: '下订单客户数',
      key: 'orderCusAmount'
    },
    {
      title: '统计期回款金额',
      key: 'receiveMoneyAmountOfDuration',
      type: 'money'
    },
    {
      title: '截止目前未收金额',
      key: 'wait2ReceiveMoneyAmount',
      type: 'money'
    },
    {
      title: '服务客户下单率',
      key: 'orderCusAmountRate',
    }
  ]

  created () {
    this.load()
  }

  mounted () {
    // 监听更多筛选
    this.$eventBus.$on('kpiMoreFilter', (res) => {
      this.queryParams.orderType = res.orderType
      this.queryParams.customerGroup = res.customerGroup
      this.queryParams.employeeName = res.employeeName
      // 刷新列表数据
      this.load()
    })
  }


  load () {
    this.queryParams.pageIndex = 1
    this.finished = false
    this.list = []
    this.getList()
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.refreshing = true
    this.load()
  }

  getList () {
    this.loading = true
    performanceStatistics({
      ...this.queryParams
    }).then(res => {
      this.list = this.list.concat(res.data.records)
      if (this.list.length >= res.data.totalRecords) {
        this.finished = true
      }
      this.queryParams.pageIndex++
      this.initTotalData(res.data)
    }).finally(() => {
      this.loading = false
      this.refreshing = false
    })
  }

  initTotalData (data: TotalDataDTO) {
    this.totalData = {
      receiveAmount: data.receiveAmount,
      receiveMoneyAmount: data.receiveMoneyAmount,
      returnMoneyAmount: data.returnMoneyAmount,
      returnAmountRate: data.returnAmountRate,
      receiveMoneyAmountOfDuration: data.receiveMoneyAmountOfDuration,
      wait2ReceiveMoneyAmount: data.wait2ReceiveMoneyAmount,
      serviveCusAmount: data.serviveCusAmount,
      orderCusAmount: data.orderCusAmount,
      orderCusAmountRate: data.orderCusAmountRate
    }
  }

  /**
   * 打开更多筛选
   */
  handleKpiMoreShow () {
    (this.$refs.KpiMore as KPIMoreFilter).showModel()
  }

  handleKpiMoreFilter (val:any) {
    this.queryParams.orderType = val.orderType
    this.queryParams.customerGroup = val.customerGroup
    this.queryParams.employeeName = val.employeeName
    this.queryParams.deptId = val.deptId
    // 刷新列表数据
    this.load()
  }

  /**
   * 头部总时间段改变
   * @param value
   */
  handleDataChange (value: Array<string>) {
    this.queryParams.startDate = value[0]
    this.queryParams.endDate = value[1]
    this.load()
  }

  /**
   * @description: 更多筛选
   * @param {*}
   * @return {*}
   */
  toMoreFilter () {
    this.$router.push({
      path: '/kpiMoreFilter',
      query: {
        employeeName: this.queryParams.employeeName as string,
        orderType: this.queryParams.orderType as string,
        customerGroup: this.queryParams.customerGroup as string
      }
    })
  }


  /**
   * 导出
   */
  handleExport () {
    exportFileWithData({
      method: 'post',
      portUrl: '/cykjreport/ER/exportPerformanceForm',
      params: JSON.stringify(Object.assign({companyId: this.companyId}, {...this.queryParams}))
    })
  }
}
